"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var moment = require("moment");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var CmsPagesRecordsListCtl = /** @class */ (function (_super) {
    __extends(CmsPagesRecordsListCtl, _super);
    function CmsPagesRecordsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_page_data_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.page_data_id; });
        _this.dk_page_data_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.page_data_title; });
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    CmsPagesRecordsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    CmsPagesRecordsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    CmsPagesRecordsListCtl.prototype.LoadData = function (pageDataId, onDone) {
        var _this = this;
        webAApi_1.ListPageRecordsByPageDataIdGet.exec({ page_data_id: pageDataId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    page_data_id: resp.list[i].page_category_id,
                    page_data_title: resp.list[i].page_category_title,
                    title: resp.list[i].title,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CmsPagesRecordsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPageRecord.exec({
            data: {
                page_category_id: data.page_data_id,
                title: data.title,
                app_language_id: data.app_language_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                page_data_id: data.page_data_id,
                page_data_title: resp.page_data_title,
                title: data.title,
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false)
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CmsPagesRecordsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPageRecord.exec({
                data: {
                    page_record_id: data.key,
                    title: data.title,
                    app_language_id: data.app_language_id
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.app_language_id = data.app_language_id;
                _tmp.app_language_title = resp.app_language_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsPagesRecordsListCtl.prototype.SetDataContent = function (pageRecordId, contentBase64, onDone) {
        var _this = this;
        var _tmp = this.getById(pageRecordId);
        if (_tmp) {
            webAApi_1.DoEditPageRecordContent.exec({
                data: {
                    page_record_id: pageRecordId,
                    content_base64: contentBase64
                }
            }, function (resp) {
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsPagesRecordsListCtl.prototype.GetDataContent = function (pageRecordId, onDone) {
        var _this = this;
        var _tmp = this.getById(pageRecordId);
        if (_tmp) {
            webAApi_1.DetailsPageRecordContentGet.exec({
                page_record_id: pageRecordId
            }, function (resp) {
                if (onDone) {
                    onDone(resp.content);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsPagesRecordsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CmsPagesRecordsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePageRecord.exec({ data: { page_record_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return CmsPagesRecordsListCtl;
}(BaseController_1.BaseController));
exports.CmsPagesRecordsListCtl = CmsPagesRecordsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_pages/ctl/CmsPagesRecordsListCtl.ts
// module id = 948
// module chunks = 0